(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.baltonTransferPricesInitialized) return;
  window.baltonTransferPricesInitialized = true;

  var selector = '[data-balton-transfer]';
  var scheduled = false;
  var cache = new WeakMap();

  function update(wrapper) {
    var card = wrapper.closest('.product-card');
    var output = wrapper.querySelector('.balton-transfer-price');
    var data = wrapper.querySelector('[data-balton-variants]');
    if (!card || !output || !data) return;

    var html = wrapper.getAttribute('data-balton-fallback-html');
    var cents = wrapper.getAttribute('data-balton-fallback-price');
    var savings = wrapper.querySelector('[data-balton-savings]');
    var savingsHtml = wrapper.getAttribute('data-balton-fallback-savings');
    var link = card.querySelector('a.product-card__title');
    var variantId = null;

    try {
      if (link) {
        variantId = new URL(
          link.getAttribute('href'),
          document.baseURI
        ).searchParams.get('variant');
      }

      if (variantId) {
        var source = data.textContent;
        var entry = cache.get(data);

        if (!entry || entry.source !== source) {
          entry = {
            source: source,
            variants: JSON.parse(source)
          };
          cache.set(data, entry);
        }

        var variant = entry.variants.find(function (item) {
          return String(item.id) === variantId;
        });

        if (
          variant &&
          Number.isSafeInteger(variant.price) &&
          variant.price >= 0
        ) {
          cents = String(Math.round(variant.price * (100 - Number(wrapper.getAttribute('data-balton-discount'))) / 10000) * 100);
          html = variant.transferHtml;
          savingsHtml = variant.savingsHtml;
        }
      }
    } catch (error) {
      // Conservar los valores calculados por Liquid.
    }

    if (
      savings &&
      typeof savingsHtml === 'string' &&
      savings.innerHTML !== savingsHtml
    ) {
      savings.innerHTML = savingsHtml;
    }

    if (typeof html === 'string' && output.innerHTML !== html) {
      output.innerHTML = html;
    }

    if (
      cents !== null &&
      output.getAttribute('data-price') !== cents
    ) {
      output.setAttribute('data-price', cents);
    }
  }

  function refresh() {
    scheduled = false;
    document.querySelectorAll(selector).forEach(update);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }

  function start() {
    refresh();

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target.parentElement;

        if (
          target &&
          target.closest('.balton-transfer-price, [data-balton-savings]')
        ) {
          return false;
        }

        if (mutation.type === 'attributes') {
          return target.matches('a.product-card__title');
        }

        return true;
      });

      if (relevant) schedule();
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['href']
    });

    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
